import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

/** "View Communications" on a customer's, agent's or carrier's page (to the conversation of its first shipment if it has one) */
export function ViewCommunicationsButton({ srb }: { srb?: string }) {
  const navigate = useNavigate();
  return (
    <Button variant="outlined" onClick={() => void navigate(srb ? `/communications/${srb}` : '/communications')}>
      View Communications
    </Button>
  );
}
